function injectStyle (ssrContext) {
  require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-00ec51e5\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"includePaths\":[\"/Users/noomz/Projects/Opendream/kadnud/kadnud-tcfe-app/src/css\"],\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./uob-lmtedu-2024-public-t-shirt.vue")
}
var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./uob-lmtedu-2024-public-t-shirt.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-00ec51e5\",\"hasScoped\":true}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./uob-lmtedu-2024-public-t-shirt.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-00ec51e5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/templates/products/uob-lmtedu-2024-public-t-shirt.vue
// module id = 404
// module chunks = 0